// news.js

const news = {
  "__split": "⋱",
  "__root": {
  	"__sort": 2,
    "Upcoming Features and Improvements": {
	  	"__sort": 2,
      "__order": -2,
      "Key 🗝️": {
        "__order": 5,
        "⚠️ means big or difficult features to implement": {},
        "🐞 means fixing a bug": {},
        "🛀 means a quality of life improvement to make things work better": {},
        "💰 means a premium feature reserved for premium users": {}
      },
      "❗ Please bear in mind that things listed here may change or disappear or not be implemented. This list represents ideas for improvements to HyperJot.io, not promises. I want to share a vision for the future of HyperJot.io, and checking out potential features may give you a glimpse into where HyperJot.io is heading.": {
        "__order": 0
      },
      "todo means this has been implemented!": {
        "__todo": true,
        "__order": 1
      },
      "💰⚠️ features set aside for premium users": {
        "__order": 2,
        "__sort": 2,
        "HyperJot.io Premium isn't a thing yet, but I want to make an upgraded version of HyperJot.io that provides the best and most requested features to those who love HyperJot.io enough to financially support its development. The free version of HyperJot.io will never go away, but for the users who want these additional features, most notably the syncing feature, it will actually cost me money to provide them so I will have to charge for them. But as long as you're paying for syncing, I can throw in other great features to make it even more worth your while! Here are some features that have been requested so far:": {
          "__order": 0
        },
        "Automatically sync your HyperJot between devices. Encrypted and secure.": {
          "__order": 1
        },
        "IFTTT integration❓": {
          "__order": 2
        },
        "Alexa integration❓": {
          "__order": 2
        },
        "Custom color schemes and premium color themes": {
          "__order": 2
        },
        "HyperJump": {
          "__order": 2
        },
        "Markdown support": {
          "__order": 2
        },
        "Emoji prefixes for Jots": {
          "__order": 2
        },
        "CLI❓": {
          "__order": 2
        },
        "Customize emojis and text for interface buttons": {
          "__order": 2
        },
        "Image upload/storage": {
          "__order": 2
        }
      },
      "🛀 quality of life improvements that will make HyperJot.io even better to use": {
        "__order": 3,
        "⚠️ Reorder Jots with drag and drop": {},
        "⚠️ Keyboard shortcuts for everything": {},
        "⚠️ Links to YouTube videos, Spotify songs, or other media will play directly in HyperJot instead of linking out to their sources": {},
        "⚠️ HyperSift will allow you to jump from the matched Jot to the real Jot to edit/manipulate it.": {},
        "⚠️ Recursively merge Jots when two identically named Jots are moved onto the same level.": {},
        "[] ⚠️ Import hyperjot.json file": {
          "__todo": true
        },
        "⚠️ Paste JSON directly into Jot to add one or more Jots": {},
        "⚠️ Configuration HyperJot": {},
        "Visual feedback on Jot after closing it": {},
        "Scroll to top of Jot after closing it if top of Jot is above the top of the screen": {},
        "[] Expanded Jots have normal sized text if there are more than a few words in it": {
          "__todo": true
        },
        "[] Toggling a to-do will update the Updated timestamp": {
          "__todo": false
        },
        "URLs don't have to be at the beginning of a Jot to create a link.": {},
        "Empty recycle bin button": {},
        "Recycle button will no longer require confirmation modal; delete button will require confirmation.": {},
        "Visual confirmation of Copy or Share button presses in the form of a toast message": {},
        "Hide hexadecimal color code when Jot is not expanded.": {},
        "Save original value of counter and add a Reset button to reset the counter to its original value.": {},
        "Create a count-up/count-down from a date or time. Need to think about how this could be useful.": {},
        "Additional math operations like multiplication, division. Not sure how to add these in though...": {},
        "[] Move emojis left of button text for easier scannability": {
          "__todo": true
        },
        "HyperSift will show where to find a given Jot in your HyperJot": {},
        "Images will be faded in so their loading is not sudden or jumpy": {}
      },
      "🐞 bugs to fix": {
        "__order": 4,
        "Image URLs that don't end in png/gif/jpg should still be displayed as images.": {},
        "[] Dice notation renders dice in reverse order.": {
          "__todo": true
        },
        "Dice notation should ignore URLs and hex color codes.": {},
        "Sum should ignore URLs, dice notation, and hex color codes.": {},
        "Export doesn't work on Edge/Windows.": {},
        "Import doesn't work on iOS": {}
      }
    },
    "0 Hello World": {
	  	"__sort": 2,
      "__order": 0,
      "Greetings and welcome to HyperJot.io! I'm really glad you decided to try it out. My name is Nick and I am a guy who likes to make things that do stuff. I created HyperJot.io because I was dissatisfied with every note app I've ever tried. Originally I just made HyperJot.io for myself but it makes me really happy to see others get use out of it. Please share it if it helps you be more efficient, productive, and organized!\n\nWhat makes HyperJot.io different from other note apps? I'm glad you asked:\n\n✨Other note apps need to be downloaded and installed or they are part of the operating system of your device. HyperJot.io doesn't need to be installed and is available on any internet-enabled device with a web browser.\n\n✨Other note apps use folders or tagging and basic search to help you organize your notes. HyperJot.io makes every note into a folder so you can structure things how you want. HyperSift allows you to create a persistent search that scans your entire HyperJot for content matching keywords or regular expressions. (Regular expressions allow you to use patterns to match text. They are used by programmers but you could learn them to make powerful HyperSifts! I believe in you!)\n\n✨Other note apps store rich text formatting but don't really let you modify it. This leads to funky formatting issues when you paste content that you copied from somewhere else. HyperJot.io only allows plain text so you never run into formatting issues. HyperJot.io is more focused on the integrity of your data, and formatting issues are never fun.\n\n✨HyperJot.io uses monospace fonts for the editing window so that you can code! Other note apps use variable-width fonts that make it hard to read code\n\n✨HyperJot.io retains your whitespace formatting so you can maintain tabbing or spacing for specially formatted text or code. This is difficult in other apps.\n\n✨HyperJot.io stores all of your data in a single JSON object, which is an extremely portable data format that is easy for humans to read. You can easily export all your HyperJot data with the press of a button, and you can import it to another device's HyperJot.io with the press of two buttons! Other apps don't bother with this kind of convenience or user empowerment.\n\n✨HyperJot.io recognizes numbers in your Jots and automatically tallies them for you, so if you're keeping a list of prices you can always see the total at a glance. Other note apps don't really attempt to intelligently interpret your data.\n\n✨Piggy backing on the sum feature, you can use basic dice notation to create a random number generator in your Jots. This random dice roll can be totaled with any other numeric Jots to create a total. Negative numbers are supported, so you can easily use this for table-top or pen-and-paper games! Or just making decisions that require some element of randomness. To roll a 20-sided die, write d20 in a Jot to see how it works!\n\n✨This is a more developer-centric feature, but you can prefix your Jot with a hexadecimal color code and it will change the Jot to be that color. For example, try putting #fa5 at the beginning of a Jot and watch it turn a pretty Instagram-orange color!\n\n✨HyperJot.io makes it insanely easy to share data with other HyperJot.io users. Just click the Share button in the current Jot and everything inside of it will be encoded into a link you can paste into a text message. When your friend clicks it, the whole Jot and everything in it will be seamlessly added to their HyperShares. Other note apps only let you share one note at a time. Lame! Why not share an entire library of notes at once? That's the HyperJot.io way of doing things.\n\n✨HyperJot.io stores all of your data in the localStorage of your web browser app. It's not synced with the cloud. Therefore, your data is as secure as your device is. Please put a password lock on your device! Clearing your caches may delete your HyperJot, so make sure to export your data periodically if you tend to clear your caches.\n\nThat's enough bragging for now. I have a list of about 20 more features I'd like to add to HyperJot.io and I will continue to actively develop it for the foreseeable future. Please let me know what you think or if you have feature requests! Be sure to check out Upcoming Features and Improvements to see what I have planned for the future.\n\nThanks for using HyperJot.io!\n\nNick": {
        "__order": 0
      },
    },
    "Social": {
      "__order": -1,
      "https://twitter.com/enchiridiontech This is me on Twitter. @ me with suggestions or feedback!": {
        "__order": 1
      },
      "https://twitter.com/hyperjot This is the official HyperJot.io Twitter account. Follow for updates, @ for anything else.": {
        "__order": 2
      },
      "https://instagram.com/hyperjot.io This is the official HyperJot.io Instagram account. Follow for inspiration!": {
        "__order": 3
      },
    }
  }
};

export default news;


// WEBPACK FOOTER //
// ./src/news.js